/** Cebuano (Bisaya) for the POS and the constituent-facing store pages (keyed by the English text). */
export const CEB_MERCHANT: Record<string, string> = {
  "Add": "Idugang",
  "Add an item paid in cash": "Pagdugang og butang nga bayran og cash",
  "All barangays": "Tanang barangay",
  "All types": "Tanang matang",
  "Allow NFC for this site, then try again.": "Tugoti ang NFC niini nga site, unya sulayi pag-usab.",
  "An SMS with the balance was sent to the card owner.": "Gipadad-an og SMS ang tag-iya sa card uban sa nahabilin nga balanse.",
  "Assistance balance": "Balanse sa ayuda",
  "Assistance transaction slip": "Slip sa transaksiyon sa ayuda",
  "Back": "Balik",
  "Back to items": "Balik sa mga butang",
  "Barangay": "Barangay",
  "Barcode {code} is not one of your approved items. Add it as an item paid in cash.": "Ang barcode {code} wala sa imong aprobadong butang. Idugang kini isip butang nga bayran og cash.",
  "Bring your card. You will be asked for your PIN at the counter.": "Dad-a ang imong card. Pangayoon ang imong PIN sa counter.",
  "Camera view for scanning barcodes": "Camera alang sa pag-scan sa barcode",
  "Cancel": "Kanselahon",
  "Cancel sale": "Kanselahon ang baligya",
  "Card ending {last}": "Card nga nagtapos sa {last}",
  "Card reader is on.": "Abli na ang card reader.",
  "Cash collected": "Nakolekta nga cash",
  "Cashier: {name}": "Cashier: {name}",
  "Check a valid ID first": "Susiha una ang valid ID",
  "Checking the card…": "Gisusi ang card…",
  "Choose a new 4-digit PIN": "Pili og bag-ong 4-digit nga PIN",
  "Choose how many of each item are returned. The amount goes back to the constituent's assistance balance.": "Pilia pila sa matag butang ang gibalik. Mobalik ang kantidad sa balanse sa ayuda.",
  "Clear": "Papasa",
  "Collect {amount} in cash": "Kolektaha ang {amount} nga cash",
  "Constituent": "Constituent",
  "Constituent no. {no}": "Constituent num. {no}",
  "Continue": "Padayon",
  "Continue to PIN": "Padayon sa PIN",
  "Covered": "Sakop sa ayuda",
  "Day": "Adlaw",
  "Day-end": "Pagsira sa adlaw",
  "Day-end summary": "Sumaryo sa pagsira sa adlaw",
  "Delete last digit": "Papasa ang katapusang numero",
  "Device": "Device",
  "Do not sell. Return the card and ask the person to visit the LGU office.": "Ayaw ibaligya. Iuli ang card ug pahibaloa nga moadto sa opisina sa LGU.",
  "Done": "Human",
  "Enter your 4-digit PIN": "Isulod ang imong 4-digit nga PIN",
  "Enter your invoice number before billing": "Isulod ang invoice number sa dili pa maningil",
  "Fill in only what changed.": "Pun-i lang ang nausab.",
  "Find item": "Pangitaa ang butang",
  "Grocery": "Grocery",
  "Hand the phone to the card owner. Do not look while they type.": "Ihatag ang telepono sa tag-iya sa card. Ayaw tan-awa samtang nag-type sila.",
  "Hold the assistance card flat on the back of the phone.": "Idapat og patag ang card sa ayuda sa likod sa telepono.",
  "ID number": "Numero sa ID",
  "ID photo added": "Nadugang ang hulagway sa ID",
  "ID type": "Matang sa ID",
  "Is this the person in front of you?": "Siya ba ang tawo nga naa sa imong atubangan?",
  "Item name": "Ngalan sa butang",
  "Item paid in cash": "Butang nga bayran og cash",
  "Items not on the approved list are recorded on the slip but paid by the customer in cash.": "Ang mga butang nga wala sa approved list makita sa slip apan bayran sa customer og cash.",
  "Less": "Kunhoran",
  "Mobile number": "Mobile number",
  "More": "Dugangan",
  "Name, birth date, photo and ID changes made at a store are checked by the LGU first.": "Ang kausaban sa ngalan, adlaw sa pagkatawo, hulagway ug ID nga gihimo sa tindahan susihon una sa LGU.",
  "Needs your invoice number": "Kinahanglan ang imong invoice number",
  "New PIN": "Bag-ong PIN",
  "Next customer": "Sunod nga customer",
  "No accredited stores here yet": "Wala pay accredited nga tindahan dinhi",
  "No approved items found.": "Walay nakit-ang aprobadong butang.",
  "No assistance balance that can be used at this store.": "Walay balanse sa ayuda nga magamit niini nga tindahan.",
  "No connection. Sales are not possible offline.": "Walay koneksyon. Dili mahimo ang pagbaligya nga offline.",
  "No sales on this day": "Walay baligya niini nga adlaw",
  "No, not the same person": "Dili, lahi nga tawo",
  "Nothing here can be paid with assistance. Collect the full amount in cash.": "Walay mabayran sa ayuda dinhi. Kolektaha ang tibuok kantidad og cash.",
  "Other": "Uban pa",
  "PIN / info": "PIN / impormasyon",
  "PIN payments are locked for this card right now. The PIN can be reset with a valid ID.": "Naka-lock karon ang pagbayad gamit ang PIN niini nga card. Ma-reset ang PIN gamit ang valid ID.",
  "POS": "POS",
  "Paid": "Bayad na",
  "Paid in cash": "Bayad og cash",
  "Paid with assistance": "Bayad gamit ang ayuda",
  "Pay in cash": "Bayri og cash",
  "Paying…": "Nagbayad…",
  "Pharmacy": "Botika",
  "Phone number or address": "Numero sa telepono o address",
  "Photo of {name}": "Hulagway ni {name}",
  "Please hand the phone to the card owner.": "Palihug ihatag ang telepono sa tag-iya sa card.",
  "Plus {amount} in cash": "Dugang {amount} nga cash",
  "Prescription seen": "Nakita ang reseta",
  "Price (₱)": "Presyo (₱)",
  "Print": "I-print",
  "Print slip": "I-print ang slip",
  "Purok / sitio": "Purok / sitio",
  "Qty": "Gidaghanon",
  "Quantity": "Gidaghanon",
  "Reason": "Rason",
  "Record and end": "Itala ug tapuson",
  "Ref": "Ref",
  "Refund": "Refund",
  "Refund items": "I-refund ang mga butang",
  "Refunded": "Na-refund",
  "Refunds": "Mga refund",
  "Register this phone": "Irehistro kini nga telepono",
  "Register this phone again": "Irehistro pag-usab kini nga telepono",
  "Remaining balance": "Nahabilin nga balanse",
  "Remove": "Kuhaa",
  "Reset the PIN with a valid ID": "I-reset ang PIN gamit ang valid ID",
  "Sale": "Baligya",
  "Sales": "Mga baligya",
  "Sales / voided": "Baligya / na-void",
  "Sari-sari store": "Sari-sari store",
  "Save": "I-save",
  "Saved": "Na-save",
  "Scan barcode": "I-scan ang barcode",
  "Search your items": "Pangitaa sa imong mga butang",
  "Sent to the LGU for approval": "Gipadala sa LGU para maaprobahan",
  "Sign in": "Pag-sign in",
  "Sign out": "Pag-sign out",
  "Start card reader": "Sugdi ang card reader",
  "Stop camera": "Isira ang camera",
  "Store invoice no.": "Invoice num. sa tindahan",
  "Store portal": "Portal sa tindahan",
  "Stores that accept the assistance card": "Mga tindahan nga modawat sa card sa ayuda",
  "Street / house": "Dalan / balay",
  "Supervisor PIN": "Supervisor PIN",
  "Take a photo of the ID (optional)": "Kuhai og hulagway ang ID (opsyonal)",
  "Tap": "I-tap",
  "Tap the card": "I-tap ang card",
  "Test card number": "Numero sa test card",
  "Test mode: use a test card number": "Test mode: gamita ang numero sa test card",
  "That is not an LGU assistance card.": "Dili kana card sa ayuda sa LGU.",
  "The camera could not be opened. Allow camera access, or type the barcode.": "Dili maabli ang camera. Tugoti ang camera, o i-type ang barcode.",
  "The card reader could not start. Check that NFC is on in the phone settings.": "Wala nagsugod ang card reader. Tan-awa kung naka-on ang NFC sa settings sa telepono.",
  "The constituent will get an SMS about this change.": "Makadawat og SMS ang constituent bahin niini nga kausaban.",
  "The face on the ID matches the person and the photo shown on the POS.": "Pareho ang nawong sa ID sa tawo ug sa hulagway sa POS.",
  "The person must be present and show a valid government ID matching {name}.": "Kinahanglan naa ang tawo ug mopakita og valid nga government ID nga mohaum kang {name}.",
  "The store owner registers it once: Store portal, then Devices, then Register this phone. Use Chrome on an Android phone with NFC.": "Kausa ra kini irehistro sa tag-iya: Portal sa tindahan, Devices, unya Irehistro kini nga telepono. Gamita ang Chrome sa Android nga naay NFC.",
  "The two PINs were different. Start again.": "Lahi ang duha ka PIN. Sugdi pag-usab.",
  "This browser cannot read cards. Use Chrome on an Android phone with NFC switched on.": "Dili makabasa og card kini nga browser. Gamita ang Chrome sa Android nga naka-on ang NFC.",
  "This browser cannot scan barcodes. Type the barcode instead.": "Dili maka-scan og barcode kini nga browser. I-type na lang ang barcode.",
  "This is not an official invoice.": "Dili kini opisyal nga resibo.",
  "This phone is not registered as a POS device": "Dili rehistrado kini nga telepono isip POS device",
  "Today's sales": "Baligya karon",
  "Total assistance": "Kinatibuk-ang ayuda",
  "Total cash collected": "Kinatibuk-ang nakolekta nga cash",
  "Total refunds": "Kinatibuk-ang refund",
  "Transaction slip": "Slip sa transaksiyon",
  "Type a barcode": "I-type ang barcode",
  "Type of store": "Matang sa tindahan",
  "Type the new PIN again": "I-type pag-usab ang bag-ong PIN",
  "Update phone number or address": "I-update ang numero sa telepono o address",
  "Uploading…": "Nag-upload…",
  "Void sale": "I-void ang baligya",
  "Voided": "Na-void",
  "Voiding cancels the whole sale and returns the full amount to the constituent's assistance balance. Only today's unbilled sales can be voided.": "Ang void mokansela sa tibuok baligya ug mobalik sa tibuok kantidad sa balanse sa ayuda. Ang baligya lang karong adlawa nga wala pa masingil ang ma-void.",
  "What did you notice? (optional)": "Unsa imong namatikdan? (opsyonal)",
  "What should change?": "Unsa ang usbon?",
  "Yes, this is the person": "Oo, siya gyud",
  "Your official invoice number": "Imong opisyal nga invoice number",
  "assistance": "ayuda",
  "cash": "cash",
  "of {total}": "sa {total}",
  "prescription": "may reseta",
  "refunded": "na-refund",
  "will be paid from your assistance": "bayran gikan sa imong ayuda",
  "{n} can be returned": "{n} ang mabalik",
  "{n} of 4 digits entered": "{n} sa 4 ka numero ang nasulod",
  "Not on the approved list": "Wala sa approved list",
  "Prescription not confirmed": "Wala pa makumpirma ang reseta",
  "Balance not enough: the rest is paid in cash": "Kulang ang balanse: ang nahabilin bayran og cash",
  "No balance left for this category": "Wala nay balanse para niini nga kategorya",
  "Above the price cap: the difference is paid in cash": "Labaw sa price cap: ang kalainan bayran og cash",
  "PhilSys National ID": "PhilSys National ID",
  "Driver's license": "Lisensya sa pagmaneho",
  "Passport": "Pasaporte",
  "Other government ID": "Uban pang government ID",
  "Accreditation": "Akreditasyon",
  "Billed": "Nasingil na",
};
